// extracted by mini-css-extract-plugin
export default {"container":"ForgotPassword_container__YxWJb"};